import { usePerpMarkets } from './usePerpMarkets';
import { useMemo } from 'react';

export const useOrderedPerpMarkets = () => {
	const perpMarkets = usePerpMarkets();
	return useMemo(
		() => perpMarkets.sort((a, b) => a.marketIndex - b.marketIndex),
		[perpMarkets]
	);
};
